import * as Actions from '../actions';

const initialState = {
    proses_rapor_mutu : {
        total: 0,
        rows: [],
        new_rows: [],
    },
    hasil_proses_rapor_mutu: '',
    final_skor: [],
    hasil_subl: [],
    hasil_indl: [],
    hasil_stdl: [],
    master_pmp: [],
    rapor_mutu_radar: [],
    rapor_mutu: {
        rows: [],
        total: 0
    },
    data_tahun: {
        rows: []
    },
    data_wilayah: {
        rows: [{
            nama_sekolah: '',
            nama_kab: ''
        }]
    },
    verval_sekolah: {
        total: 0,
        rows: [],
    },
    timeline: [{
        "o" : "k"
    }],
    active_step: 0
};

const raporMutuReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_DATA_TAHUN:
        {
            return {
                ...state,
                data_tahun: action.data_tahun
            };
        }
        case Actions.SET_DATA_WILAYAH:
        {
            return {
                ...state,
                data_wilayah: action.data_wilayah
            };
        }
        case Actions.SET_ACTIVE_STEP:
        {
            return {
                ...state,
                active_step: action.active_step
            };
        }
        case Actions.GET_RAPOR_MUTU_RADAR:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                rapor_mutu_radar: action.payload
            };
        }
        case Actions.GET_RAPOR_MUTU:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                rapor_mutu: action.payload
            };
        }
        case Actions.HITUNG_MASTER_PMP:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                master_pmp: action.payload
            };
        }
        case Actions.HITUNG_HASIL_STDL:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_stdl: action.payload
            };
        }
        case Actions.HITUNG_HASIL_INDL:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_indl: action.payload
            };
        }
        case Actions.HITUNG_HASIL_SUBL:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_subl: action.payload
            };
        }
        case Actions.HITUNG_FINAL_SKOR:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                final_skor: action.payload
            };
        }
        case Actions.PROSES_RAPOR_MUTU:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_proses_rapor_mutu: action.payload
            };
        }
        case Actions.GET_PROSES_RAPOR:
            {
            return {
                ...state,
                routeParams: action.routeParams,
                proses_rapor_mutu: action.payload
            };
        }
        case Actions.GET_TIMELINE:
            {
            return {
                ...state,
                routeParams: action.routeParams,
                timeline: action.payload
            };
        }
        case Actions.GET_VERVAL_SEKOLAH:
            {
            return {
                ...state,
                routeParams: action.routeParams,
                verval_sekolah: action.payload
            };
        }
        default:
        {
            return state;
        }
    }
}

export default raporMutuReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/RaporMutu.reducers.js